import { render, staticRenderFns } from "./PriceSpecifications.vue?vue&type=template&id=6e1e5586&scoped=true&"
import script from "./PriceSpecifications.vue?vue&type=script&lang=js&"
export * from "./PriceSpecifications.vue?vue&type=script&lang=js&"
import style0 from "./PriceSpecifications.vue?vue&type=style&index=0&id=6e1e5586&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e5586",
  null
  
)

export default component.exports